export default {
    "created": "Reseller-ul a fost creat cu succes",
    "updated": "Reseller-ul a fost actualizat cu succes",
    "deleted": "Reseller-ul a fost șters cu succes",
    "restored": "Reseller-ul a fost restaurat cu succes",
}
